<div class="card-contents" id="topup">
<a class="close-cc-form" *ngIf="!!showTopupSection && !planId && !noteDesc" (click)="reset()">
  <img src="/assets/icon/primary-close.svg" alt="close" width="32" height="32">
</a>
  <ng-container *ngIf="!showTopupSection">
    <h5 class="card-desc">{{!!redeemVoucherFlow? 'Top up your account anytime, anywhere.' : 'Ready to make a payment?'}}</h5>
    <p class="desc-note smaller">Make sure your account has the funds needed for your next plan renewal.</p>
    <button class="button primary" aria-label="get started" (click)="openTopUpSection()">
     {{!!redeemVoucherFlow? 'Get Started' : 'Make a Payment'}}
    </button>
  </ng-container>
  <ng-container *ngIf="!!showTopupSection"> 
    <div *ngIf="showMdnStep">
    <ng-container  *ngIf="!!redeemVoucherFlow">
      <h5 class="card-desc" translate>
        landing-page.confirm-your-number
      </h5>
      <form [formGroup]="quickTopUpForm" (ngSubmit)="goToVoucher()" class="topup-form">
        <div class="form-field">
          <label class="outlined-label-input">
            <input id="phoneNumber" type="tel" appPhoneMask [inputId]="'phoneNumber'"
              [preValue]="quickTopUpForm.value.phoneNumber" (paste)="onPaste($event)"
              [phoneControl]="quickTopUpForm.controls['phoneNumber']" formControlName="phoneNumber" restrictNumbers
              placeholder=" " maxlength="14" autocomplete="off" />
            <span translate>landing-page.mobile-number</span>
          </label>
          <label class="validation-message" id="required-mdn-msg"
            *ngIf="quickTopUpForm.controls['phoneNumber'].touched && !quickTopUpForm.controls['phoneNumber'].value"
            translate>
            activate-number.phone-number-required
          </label>
          <label class="validation-message" id="invalid-mdn-msg"
            *ngIf="quickTopUpForm.controls['phoneNumber'].touched && !!quickTopUpForm.controls['phoneNumber'].value && quickTopUpForm.hasError('matchingDigits')"
            translate>
            activate-number.phone-number-invalid
          </label>
        </div>
        <div class="form-field last">
          <label class="outlined-label-input">
            <input id="confirmPhoneNumber" type="tel" appPhoneMask [inputId]="'confirmPhoneNumber'"
              [preValue]="quickTopUpForm.value.confirmPhoneNumber" (paste)="onPaste($event)"
              [phoneControl]="quickTopUpForm.controls['confirmPhoneNumber']" formControlName="confirmPhoneNumber"
              restrictNumbers placeholder=" " maxlength="14" autocomplete="off" />
            <span translate>landing-page.confirm-mobile-number</span>
          </label>
          <label class="validation-message" id="required-confirm-mdn-msg"
            *ngIf="quickTopUpForm.controls['confirmPhoneNumber'].touched && !quickTopUpForm.controls['confirmPhoneNumber'].value"
            translate>
            landing-page.confirm-mobile-number-required
          </label>
          <label class="validation-message" id="invalid-confirm-mdn-msg"
            *ngIf="quickTopUpForm.controls['confirmPhoneNumber'].touched && !!quickTopUpForm.controls['confirmPhoneNumber'].value && quickTopUpForm.hasError('mismatchedPhoneNumber')"
            translate>
            landing-page.mismatched-phone-number
          </label>
        </div>
        <div class="form-actions">
          <button class="button primary" type="submit" id="verify-button" translate>landing-page.proceed</button>
        </div>
      </form>
    </ng-container>
    <ng-container  *ngIf="!redeemVoucherFlow">
       <h5 class="card-desc" >
        Select Your Phone Number
      </h5>
      <form [formGroup]="selectMdnForm" (ngSubmit)="next()" class="topup-form">
      <div class="form-field">
            <div class="floating-label">
            <select formControlName="phoneNumber" class="floating-select" name="mdns">
              <option value="" disabled selected>Select Phone Number</option>
              <option *ngFor="let number of numbers" [value]="number?.mdn">
                {{ number?.mdn }}
              </option>
            </select>
             <label>SpeakOut Wireless Number</label>
            </div>                    
          </div>
          <div class="voucher-action">
        <button class="button primary" type="submit"> Verify</button>
      </div>
      </form>
    </ng-container>  
    </div>
  <ng-container *ngIf="!redeemVoucherFlow">
   <div *ngIf="!canTopup">
      <div class="success-banner">
        <div class="banner-box">
            <div class="flex">
                <img src="assets/icon/circled-green-check.svg" width="32" height="32"
                    alt="Success Icon">
                <div class="banner-content">
                    <p class="desc-a smaller">Your available account balance is enough to cover your next plan renewal. <b>No
payment is needed at this time.</b> Your plan renewal amount will automatically be
deducted from your available account balance on your renewal date.</p>
                  
                </div>
                
            </div>
            <div class="banner-actions">
                <button class="button primary" (click)="reset()" translate>landing-page.got-it</button>
            </div>
        </div>
    </div>
    </div>
    <div class="container" *ngIf="showVoucherStep && canTopup">
      <h5 class="card-desc">Make a Payment</h5>
      <p class="smaller note"><b>Your next plan renewal is {{renewAmount | currency:'CAD':'symbol-narrow':'1.2-2'}}</b>, Your available account balance is {{accountBalance | currency:'CAD':'symbol-narrow':'1.2-2'}}.</p>
        <p class="smaller"><b>Payment needed for your next renewal: {{(renewAmount - accountBalance) | currency:'CAD':'symbol-narrow':'1.2-2'}}</b></p>
      <p class="smallest" *ngIf="(renewAmount - accountBalance) < 2.5">The minimum payment is <b>$2.50</b>. Any remaining funds after your plan renews will stay in your Available Account Balance.</p>
      <label class="outlined-label-input">
        <input id="balance" class="amount-input" type="number" 
          [max]="maxRefillAmount" min="2.5" [(ngModel)]="balance"   step="0.01" 
          #balanceModel="ngModel" required  placeholder=" " disabled>
        <span>Payment Amount</span>
      </label>
      <p class="smaller bold validation-message" *ngIf="balanceModel.errors?.['required'] && balanceModel.touched && (!balance || balance < 0.01) " translate>
        landing-page.please-select-voucher
      </p>
      <p class="smaller bold validation-message" *ngIf="balanceModel.errors?.['max'] && balance > maxRefillAmount" translate>
        landing-page.max-amount-error <span>{{maxRefillAmount | currency:'CAD':'symbol-narrow':'1.2-2'}}</span>
      </p>
      <p class="smaller bold validation-message" *ngIf="balanceModel.errors?.['min'] && balance < 0.01" translate>
        landing-page.min-amount-error
      </p>
      <div class="voucher-action">
        <button class="button primary" (click)="goToShopify()">Continue to Payment</button>
      </div>
    </div>
    </ng-container>
    <ng-container *ngIf="!!redeemVoucherFlow">
       <div *ngIf="showVoucherStep">
        <h5 class="card-desc">Enter Voucher Code/PIN</h5>
        <p class="smaller desc-b last">Top-Up will be added to your phone number <b>{{mdn}}</b></p>
         <form [formGroup]="voucherForm" (ngSubmit)="submitTopup()" class="topup-form">
        <div class="form-field">
          <label class="outlined-label-input">
            <input id="voucherNumber" type="tel" 
              (paste)="onPaste($event)"
              formControlName="voucherNumber" restrictNumbers minlength="12"
              placeholder=" " maxlength="16" autocomplete="off" />
            <span >Voucher Code</span>
          </label>
          <label class="validation-message" id="required-mdn-msg"
            *ngIf="voucherForm.controls['voucherNumber'].touched && !voucherForm.controls['voucherNumber'].value"
            >
            Voucher code is required.
          </label>
          <label class="validation-message" id="invalid-mdn-msg"
            *ngIf="voucherForm.controls['voucherNumber'].dirty && !!voucherForm.controls['voucherNumber'].value && voucherForm.hasError('minLength')"
            >
            Voucher code is invalid.
          </label>
        </div>
        <div class="form-field last">
          <label class="outlined-label-input">
            <input id="confirmVoucherNumber" type="tel" 
               (paste)="onPaste($event)"
               formControlName="confirmVoucherNumber" minlength="12"
              restrictNumbers placeholder=" " maxlength="16" autocomplete="off" />
            <span>Confirm Voucher Code</span>
          </label>
          <label class="validation-message" id="required-confirm-voucher-msg"
            *ngIf="voucherForm.controls['confirmVoucherNumber'].touched && !voucherForm.controls['confirmVoucherNumber'].value"
            translate>
            Voucher code confirmation is required
          </label>
          <label class="validation-message" id="invalid-confirm-voucher-msg"
            *ngIf="voucherForm.controls['confirmVoucherNumber'].touched && !!voucherForm.controls['confirmVoucherNumber'].value && voucherForm.hasError('mismatchedVoucherNumber')"
            translate>
            Voucher code do not match
          </label>
        </div>
        <div class="form-actions">
          <button class="button primary" type="submit" id="submit-button" translate>Submit</button>
        </div>
      </form>
       </div>
    </ng-container>
  </ng-container>
</div>
